import { render, staticRenderFns } from "./MenuRoutes.vue?vue&type=template&id=15300fc8&scoped=true"
import script from "./MenuRoutes.vue?vue&type=script&lang=js"
export * from "./MenuRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15300fc8",
  null
  
)

export default component.exports